import React, { useEffect, useState } from 'react';

import { Button, message, Table } from 'antd';
import { BalanceService } from 'services/BalanceService';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { useDocumentTitle } from 'hooks/useDocumentTitle';

function Balance() {
  useDocumentTitle('Баланс БЦК');
  useHeaderChanger('Баланс БЦК');
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState([]);

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    setLoading(true);

    try {
      const balance = await BalanceService.getBalance();

      setBalance(balance);
    } catch (err) {
      message.error('Не удалось загрузить баланс');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionsWrapper placeEnd>
        <Button type="primary" onClick={fetchBalance}>
          Обновить
        </Button>
      </ActionsWrapper>

      <Table
        columns={[
          {
            title: 'Наименование',
            dataIndex: 'title',
            key: 'title',
            render: (value) => {
              switch (value) {
                case 'balance':
                  return 'Общий баланс';
                case 'processed':
                  return 'В Процессе';
                case 'threshold':
                  return 'Мин.сумма';
                default:
                  return 'Баланс';
              }
            },
          },
          {
            title: 'Баланс',
            dataIndex: 'balance',
            key: 'balance',
          },
        ]}
        dataSource={balance}
        loading={loading}
        pagination={false}
        rowKey="title"
      />
    </>
  );
}

export { Balance };
